import type WalkerService from '../../services/walker.service';
import type {ModalWindowActions} from '../conversation';
import {PopupBlockerError} from '../../errors';
import type {RedirectionResponse} from 'typings/portaro.be.types';
import {responseTypes} from '../../constants/portaro.constants';

export default class RedirectionResponseController {
    public static controllerName = 'RedirectionResponseCtrl';

    public error: any;
    private popupBlocked: boolean;

    /*@ngInject*/
    constructor(private walker: WalkerService) {
    }

    public init(model: RedirectionResponse, modalWindowActions: ModalWindowActions) {
        try {
            this.go(model); // do not 'await'
            modalWindowActions.submitPromise(Promise.resolve({
                responseType: responseTypes.FINISHED_RESPONSE,
                finished: true
            }));
        } catch (e) {
            this.error = e;
            this.popupBlocked = e instanceof PopupBlockerError;
        }
    }

    private async go(model: RedirectionResponse) {
        switch (model.strategy) {
            case 'AUTO': return this.walker.newPageDetectNewWindow(model.url, null);
            case 'CURRENT_WINDOW': return this.walker.newPage(model.url, null);
            case 'NEW_WINDOW': return this.walker.newPageInNewWindow(model.url, null);
        }
    }
}
